module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputBox"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.disabled) ? _c('label', {
    staticClass: "forInput"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('input', {
    style: ({
      'height': _vm.height
    }),
    attrs: {
      "type": _vm.secret ? 'password' : 'text'
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.input($event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hintArea"
  }, [(!_vm.disabled && _vm.value == "") ? _c('span', [_vm._v(_vm._s(_vm.hintMsg))]) : _vm._e()]), _vm._v(" "), (_vm.extendType != "") ? _c('div', {
    staticClass: "rightExtend"
  }, [(_vm.extendType == "button") ? _c('span', {
    staticClass: "btn radius",
    class: {
      lock: _vm.extendLock || _vm.innerLock
    },
    on: {
      "click": _vm.clickExtend
    }
  }, [_vm._v(_vm._s(_vm.extendMsg))]) : _vm._e(), _vm._v(" "), (_vm.extendType == "icon") ? _c('img', {
    attrs: {
      "src": _vm.extendSrc
    },
    on: {
      "click": _vm.clickExtend
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37d591ed!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/inputBox.vue
// module id = 189
// module chunks = 17 18